export default {
      id: "ic-fil-live-light-grey-usage",
      viewBox: "0 0 21 18",
      url: "/" + "images/icons.3.109.2.svg#ic-fil-live-light-grey-usage",
      toString: function () {
        return this.url;
      }
    }